import { useRef } from "react";
import useElementDimensions from "../../utils/useElementDimensions";

export default function Square({ children }) {
  const squareRef = useRef();
  const dimensions = useElementDimensions(squareRef);

  return children({ squareRef, dimensions });
}
